import { useAuthStore } from '@/stores/auth-store'
import { useUiStore } from '@/stores/ui-store'
import { Menu, LogOut, Search } from 'lucide-react'
import AccessibilityToggle from '@/components/AccessibilityToggle'

export default function Navbar() {
  const user = useAuthStore((state) => state.user)
  const logout = useAuthStore((state) => state.logout)
  const toggleSidebar = useUiStore((state) => state.toggleSidebar)
  const openCommandPalette = useUiStore((state) => state.toggleCommandPalette)

  const handleLogout = () => {
    logout()
    window.location.href = '/login'
  }

  return (
    <nav className="fixed top-0 left-0 right-0 bg-white border-b border-gray-200 h-16 z-50">
      <div className="h-full px-3 sm:px-4 flex items-center justify-between">
        <div className="flex items-center gap-2 sm:gap-4 min-w-0">
          {/* Hamburger — mobile only (toggles overlay sidebar) */}
          <button
            onClick={toggleSidebar}
            className="md:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="Otwórz menu boczne"
          >
            <Menu className="w-5 h-5" />
          </button>
          <h1 className="text-lg sm:text-xl font-bold text-primary truncate">ZAMEK</h1>
        </div>

        <div className="flex items-center gap-1 sm:gap-2 md:gap-4">
          {/* Search — desktop (full with ⌘K hint) */}
          <button
            onClick={openCommandPalette}
            className="hidden sm:inline-flex items-center gap-2 px-3 py-1.5 text-sm text-gray-500 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg transition-colors"
            title="Otwórz wyszukiwanie (Ctrl+K / Cmd+K)"
            aria-label="Otwórz wyszukiwanie"
          >
            <Search className="w-4 h-4" />
            <span>Szukaj</span>
            <kbd className="hidden md:inline-flex items-center px-1.5 py-0.5 ml-2 text-[10px] font-mono bg-white border border-gray-300 rounded">
              ⌘K
            </kbd>
          </button>
          {/* Search — mobile (icon only) */}
          <button
            onClick={openCommandPalette}
            className="sm:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors text-gray-600"
            title="Wyszukiwanie"
            aria-label="Otwórz wyszukiwanie"
          >
            <Search className="w-5 h-5" />
          </button>
          {/* User name — hidden on small screens to save space */}
          <span className="hidden md:inline text-sm text-gray-600 truncate max-w-[160px]">
            {user?.first_name} {user?.last_name}
          </span>
          <AccessibilityToggle />
          <button
            onClick={handleLogout}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors text-gray-600 hover:text-destructive"
            title="Wyloguj"
            aria-label="Wyloguj"
          >
            <LogOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </nav>
  )
}
